<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    沙尾站<br>
站点介绍<br>
沙尾站位于沙尾路与福强路交叉口，东侧为福强路，西侧为金地一路，南侧为沙尾路，北侧为新洲三街。其中新洲村和商业区及居民小区位于车站北侧，沙尾村和金地工业区位于车站南侧，车站装修以米白色及黄色为主色调，以LED环形造型灯具为设计特色，通过色彩变化、材料对比、灯光效果等处理手法，最大限度地改善地下封闭空间的沉闷和压抑感，为乘客提供舒适便利的乘车环境。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:32	23:31	7号线	3分35秒	5分55秒<br>
太安	06:05	23:26	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:26	23:31	7号线	4分钟	5分55秒<br>
太安	06:04	23:26	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:26	00:31	7号线	4分钟	5分55秒<br>
太安	06:04	00:26	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
福强路南侧（西）、沙尾路、金地名轩、福田公安分局行政服务中心、福田区人民法院执行局<br><br>
B出入口:<br>
福强路南侧（东）、沙尾路、元盛兴苑、沙尾村、星河锦居、深圳文化创意园、沙尾文化综合楼、沙尾文化广场、棠彩楼、中国工商银行、沙尾幼儿园<br><br>
C出入口:<br>
福强路北侧（东）、新洲三街东侧、天佑楼、新洲文化广场、华庭居、帝堡城、天富阁、新沙小学、福田维多利亚幼儿园<br><br>
D出入口:<br>
福强路北侧（西）、绿景花园、宝鸿苑、凯欣园、深圳市广业幼儿园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 沙尾<br>
44,71,M172,377,B685,80,M370,M347,202,303,317,322,339,M453,M500,,M519<br><br>
B出入口:<br>
公交站名： 新洲村<br>
26,80,44,71,103,,202,,317,322,339,M172377,B685,B689,,M370,M433,M453,,M347,M500,M519,M511 303<br><br>
C出入口:<br>
公交站名： 新洲村<br>
44,71,80,103,202,M453,M347,317,322,339,M172,377,B685, M519,B689,M433,M500,26<br><br>
D出入口:<br>
公交站名： 沙尾<br>
44,71,80,202,303,317,322,339,M172,377,B685，M453,M347,M500,M519<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>